import { render, staticRenderFns } from "./FileCollection.vue?vue&type=template&id=5ce24e14&scoped=true&"
import script from "./FileCollection.vue?vue&type=script&lang=js&"
export * from "./FileCollection.vue?vue&type=script&lang=js&"
import style0 from "./FileCollection.vue?vue&type=style&index=0&id=5ce24e14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ce24e14",
  null
  
)

export default component.exports